// Apply a guest menu (from the FudiTap API) as the active tenant BEFORE the
// session/cart/order providers mount, so every scoped storage key, label and
// menu read belongs to this card's restaurant only.
//
// Demo-tenant facts that the API does not provide (promotions, combos, featured
// items, loyalty, links, rating, hours, open state, prep/kitchen estimates) are
// cleared, never carried over: a real guest must not see another restaurant's
// demo data.
import { restaurantConfig, loyaltyCampaign } from "@/config/restaurantConfig";
import { restaurant } from "@/data/restaurant";
import { installMenu } from "@/data/menu";

export function applyGuestTenant(menu, cardCode, scopeOverride) {
  // Local storage scope per card/table entry (no backend tenant IDs are sent to the guest).
  const scope = scopeOverride || `card_${cardCode}`;
  const branch = { id: scope, name: menu.restaurant.branchName, city: "" };
  const cleared = {
    tagline: null, logoImage: null, isOpen: null, hours: "", avgPrepTimeMin: null,
    rating: null, reviewCount: null,
  };
  Object.assign(restaurantConfig, cleared, {
    id: scope, name: menu.restaurant.name, branch,
    prepRangeMin: null, kitchenLoad: null, coverImage: null, links: {},
    featuredIds: [], comboIds: [], promotions: [],
  });
  Object.assign(restaurant, cleared, {
    id: scope, name: menu.restaurant.name, branch, heroImage: null,
  });
  Object.assign(loyaltyCampaign, { enabled: false, branchIds: [] });
  installMenu(menu);
}
